import {observer} from "mobx-react-lite";
import {useState} from "react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {DividerBox} from "../../../basic-ui-components/layout/divider/divider.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {FlexContainerBox} from "../../../themes/architecture/css-helpers/flex";
import {JBOptinReminderCheckboxBox} from "./boxes/content/jb-optin-reminder-checkbox/checkbox/jb-optin-reminder-checkbox.box";
import {JBOptinReminderLabelBox} from "./boxes/content/jb-optin-reminder-checkbox/label/jb-optin-reminder-label.box";
import {JBOptInReminderContentBox} from "./boxes/content/jb-optin-reminder-content.box";
import {JBOptInReminderTextContentBox} from "./boxes/content/jb-optin-reminder-text-content/jb-optin-reminder-text-content.box";
import {JBOptInReminderHeaderOuterFrameBox} from "./boxes/header/outer/jb-optin-reminder-header-outer-frame.box";
import {JBOptInReminderHeaderBox} from "./boxes/header/inner/jb-optin-reminder-header.box";
import {JBOptInReminderDialogBox} from "./boxes/jb-optin-reminder-dialog.box";
import {CyClass} from "../../../../common/cy-classes";
import {JackpotBetsOptinReminderLogoBox} from "./boxes/header/logo/jackpot-bets-optin-reminder-logo.box";

interface JackpotBetsOptinReminderDialogProps {
    updateDontShowAgainPreference: (value: boolean) => void;
}
export const JackpotBetsOptinReminderDialogComponent: React.FC<JackpotBetsOptinReminderDialogProps> = observer((props) => {
    const services = useServices();
    let [isDontShowAgain, setIsDontShowAgain] = useState(false);
    return (
        <JBOptInReminderDialogBox>
            <JBOptInReminderHeaderOuterFrameBox>
                <JBOptInReminderHeaderBox>
                    <JackpotBetsOptinReminderLogoBox/>
                </JBOptInReminderHeaderBox>
            </JBOptInReminderHeaderOuterFrameBox>
            <JBOptInReminderContentBox>
                <JBOptInReminderTextContentBox className={CyClass('cy-jackpot-bet-opt-in-reminder-text')}>
                    {services.translation.translate('JACKPOT_BETS_REMINDER_BODY', {
                       jackpotBetContribution: services.currency.formatMoney(services.jackpotBet.participationFee, true)
                    })}
                </JBOptInReminderTextContentBox>
                <Button
                    preset="primary"
                    fullWidth
                    className={'cy-jackpot-bet-opt-in-reminder-button'}
                    onClick={() => props.updateDontShowAgainPreference(isDontShowAgain)}>
                    {services.translation.translate("GOT_IT")}
                </Button>
                <DividerBox marginBottom="12px" style={{width: "100%", margin:"12px 0px 12px 0px"}} />
                <FlexContainerBox alignItems="center" className={'cy-jackpot-bet-opt-in-reminder-checkbox'}>
                    <JBOptinReminderCheckboxBox
                        id="dontShowAgain"
                        name="dontShowAgain"
                        value="true"
                        checked={isDontShowAgain}
                        onChange={(e) => {
                            setIsDontShowAgain(e.target.checked);
                            services.jackpotBet.sendJackpotBetEvent('jackpot_bet_opt_in_reminder_dont_show_again', String(e.target.checked));
                        }}
                    />
                    <JBOptinReminderLabelBox htmlFor="dontShowAgain">{services.translation.translate("JACKPOT_BET_DONT_SHOW_AGAIN")}</JBOptinReminderLabelBox>
                </FlexContainerBox>
            </JBOptInReminderContentBox>
        </JBOptInReminderDialogBox>)
});
